import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { CadastroCertificadoRecebiveisApiRequest, GrupoAcesso, Perfil } from 'common/genericTypes';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { Button, MdSpace, SmSpace, TextField } from 'm2m.components';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import { addAlert } from 'store/modules/snackBar';
import CertificadoRecebiveisParser from 'utils/parsers/certificadoRecebiveisParser';

export function FormularioDrawerEdicao({
  open,
  setOpen,
  handleSubmit,
  codigo,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  codigo: string;
}) {
  const dispatch = useDispatch();
  const [documento, setDocumento] = useState<File | undefined>();
  const [justificativa, setJustificativa] = useState<string>('');

  const caracteristicas = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.caracteristicas);
  const criteriosRemuneracao = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.criteriosRemuneracao);
  const eventos = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.eventos);
  const uploadDocumentos = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.uploadDocumentos);
  const emissor = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.emissor);
  const certificadoRecebiveisComercialId = useSelector((state: RootState) => state.certificadoRecebiveisCadastro.caracteristicas.id);
  const isUsuarioOperacoesMaster = useSelector(
    (state: RootState) =>
      state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes &&
      state.auth.usuario.participante.perfil === Perfil.Master);
  const certificadoRecebiveisApi = useSelector((state: RootState) => state.certificadoRecebiveisApi);

  const handleUpdateFileToStore = (attachments: Attachment[]): void => {
    const newAttachment = attachments?.[0].file;
    setDocumento(newAttachment);
  };

  const submitPutCertificadoRecebiveisEdicao = async (
    certificadoRecebiveisComercialId: string,
    certificadoRecebiveisComercial: CadastroCertificadoRecebiveisApiRequest,
  ): Promise<string> => {
    try {
      if (justificativa) {
        const result = await certificadoRecebiveisApi.putEditarCertificadoRecebiveis(
          dispatch,
          certificadoRecebiveisComercialId,
          certificadoRecebiveisComercial,
          justificativa,
          documento,
          true
        );
        return result.data;
      } else throw 'O campo de justificativa é obrigatório';
    } catch (error: any) {
      console.log(error);
      dispatch(addAlert({ message: error, severity: 'error' }));
    }
    return codigo;
  };

  
    const submitDocument = async (
      certificadoRecebiveisId: string,
      emissionType: string,
      file: File
    ): Promise<UploadDocResponse[]> => {
      try {
        return certificadoRecebiveisApi.putUploadDoc(dispatch, certificadoRecebiveisId, emissionType, file, true);
      } catch (error) {
        return [];
      }
    };

  const handleEdicaoSubmit = async () => {
    try {
      const cr: CadastroCertificadoRecebiveisApiRequest = CertificadoRecebiveisParser.stateToCadastroCertificadoRecebiveisApiRequest(
        caracteristicas,
        criteriosRemuneracao,
        eventos,
        uploadDocumentos,
        emissor
      );
      if (!certificadoRecebiveisComercialId) throw 'Erro ao editar o Certificado de Recebíveis.';

      for (const document of uploadDocumentos.documents) {
        if (document.file) {
          const uploadResponse = await submitDocument(certificadoRecebiveisComercialId, document.type, document.file);
          if (!uploadResponse || uploadResponse.length === 0) return { codigo: '', ticket: '' };
        }
      }
      
      if (isUsuarioOperacoesMaster)
        {
          if (caracteristicas.id) {
            for (const documentToDelete of uploadDocumentos.documentsToDelete) {
              documentToDelete.remoteFileInfo?.id &&
              (await certificadoRecebiveisApi.deleteUploadDoc(dispatch, certificadoRecebiveisComercialId, documentToDelete.remoteFileInfo.id, true));
            }
          }
        }

      const result = await submitPutCertificadoRecebiveisEdicao(certificadoRecebiveisComercialId, cr);
      if (!result) throw 'Erro ao editar o Certificado de Recebíveis';

      dispatch(addAlert({ message: `Instrumento Financeiro ${result} editado com sucesso.`, severity: 'success' }));
      handleSubmit();

    } catch (error: any) {
      dispatch(addAlert({ message: error.message, severity: 'error' }));
      throw error;
    }
  };

  const handleClose = () => {
    setDocumento(undefined);
    setJustificativa('');
    setOpen(false);
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { padding: '40px', maxWidth: 460 } }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3">{'Edição'}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <MdSpace />
          <Typography variant="body2">{`Tem certeza que quer editar o instrumento financeiro ${codigo}?`}</Typography>
          <SmSpace />
          <TextField
            value={justificativa}
            label="Justificativa"
            onChange={(value) => setJustificativa(value)}
            multiline
            rows={4}
            required
          />
          <SmSpace />
          <UploadDocs
            multipleFiles={false}
            inputAttachments={[]}
            onChange={handleUpdateFileToStore}
          />
          <MdSpace />
          <Button
            onClick={handleEdicaoSubmit}
            disabled={!justificativa}
            variant="contained"
            color="primary"
            fullWidth
          >
            {'Confirmar Edição'}
          </Button>
          <SmSpace />
          <Button onClick={handleClose} variant="contained" color="error" fullWidth>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
}
